import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchAgroExporterProcesses(agro_exporter_id) {
    return RequesterV1.get(`agro_exporter/production/query_container_export/list_processes/${agro_exporter_id}`);
  },
};
